import { baseAPI } from "../../utils/constants";
import { getUserMetadata, getKey } from "../../utils/localStorage";
import { getRequest } from "../../services/Requests";

export enum ADMIN_ACTIONS {
  GET_DEVICES_OK = "GET_DEVICES_OK",
  GET_DEVICES_ERROR = "GET_DEVICES_ERROR",
  GET_DEVICES_PENDING = "GET_DEVICES_PENDING",
}

export const getDevicesOK = (payload) => ({ type: ADMIN_ACTIONS.GET_DEVICES_OK, payload });
export const getDevicesPending = () => ({ type: ADMIN_ACTIONS.GET_DEVICES_PENDING });
export const getDevicesFailed = (message) => ({ type: ADMIN_ACTIONS.GET_DEVICES_PENDING, message });

export const getDevices = (userName: string, password: string) => async (dispatch) => {
    dispatch(getDevicesPending());
    try {
      const { uid } = getUserMetadata(getKey("token"));
      const response = await getRequest<any>({
        url: `devices/${uid}`,
      });
      dispatch(getDevicesOK(response.data));
    } catch (error) {
      dispatch(getDevicesFailed("unable to login"));
    }
};
